import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

export function useMultiShipmentProjectBookingsAsCarrier(
  shipmentId: number | undefined,
) {
  const { role } = useRoleContext();

  const url =
    role != null && shipmentId !== undefined
      ? `/carriers/${role.id}/projects/${shipmentId}/bookings`
      : null;

  const { data, loading, error, refetch } = useSwrFetch<
    MultiShipmentProjectBooking[]
  >({
    url,
    errorMessage: "Failed to fetch project bookings",
  });

  return {
    projectBookings: data ?? [],
    refetchBookings: refetch,
    loading,
    error,
    success: data !== undefined && error == null,
  };
}
